import React, { Component } from 'react';

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      message: '',
    }
  }
  render() {

    if(this.props.data){
      var message = this.props.data.contactmessage;
    }

    return (
      <section id="contact">
        <div className="row section-head">
          <div className="twelve columns">
            <h1>&emsp;MY COMMUNITY INVOLVEMENTS :</h1>&emsp;
            <a href="https://www.codechef.com/users/us22"><img src="images/thumbs/1.png" width="65" height="65" alt="Codechef" /></a>&ensp;
            <a href="https://www.hackerrank.com/infoutkarsh"><img src="images/thumbs/6.png" width="65" height="65" alt="HR" /></a>&ensp;
            <a href="https://gssoc.girlscript.tech/"><img src="images/thumbs/3.png" width="65" height="65" alt="GirlScript" /></a>&ensp;
            <a href="https://codeforces.com/profile/CR0SS"><img src="images/thumbs/2.jpg" width="65" height="65" alt="Codeforce" /></a>&ensp;
            <a href="https://auth.geeksforgeeks.org/user/infoutkarsh/practice"><img src="images/thumbs/4.png" width="65" height="65" alt="GFG" /></a>&ensp;
            <a href="https://badgr.com/public/assertions/nUudUZ6ISIW1rN2eA1o1mg?action=download"><img src="images/thumbs/78.png" width="65" height="65" alt="GFG" /></a>&ensp;
            <a href="https://developers.google.com/community/dsc"><img src="images/thumbs/5.png" width="65" height="65" alt="GDC" /></a>
            <p className="lead">&emsp;{message}</p>
            <a href="mailto:utkarshus2000@gmail.com"><button>CONTACT ME</button></a>
          </div>
        </div>
        </section>
    );
  }
}

export default Contact;
